import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInjection: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconInjection"><Path d="M22.207 5.79297L20.793 7.20703L19.5 5.91406L17.9141 7.5L21.207 10.793L19.793 12.207L18.5 10.9141L9.5 19.9141L7.5 17.9141L3.70703 21.707L2.29297 20.293L6.08594 16.5L4.08594 14.5L13.0859 5.5L11.793 4.20703L13.207 2.79297L16.5 6.08594L18.0859 4.5L16.793 3.20703L18.207 1.79297L22.207 5.79297Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInjection;
